module.exports = __webpack_public_path__ + "components/scroll-button/static/icon-chevron-circle-left-4bbe1d0ef89ba8cd1228c357d0db6f84.svg";